'use strict'

// 简单本地缓存（localStorage + TTL）
// 数据结构：{ expiresAt: number, data: any }

export function setCache(key, data, ttlMs) {
  try {
    const payload = {
      expiresAt: Date.now() + (typeof ttlMs === 'number' ? ttlMs : 0),
      data
    }
    localStorage.setItem(key, JSON.stringify(payload))
  } catch (e) {
    // 忽略写入失败
  }
}

export function getCache(key) {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return null
    const payload = JSON.parse(raw)
    if (!payload || typeof payload.expiresAt !== 'number') return null
    if (Date.now() > payload.expiresAt) return null
    return payload.data
  } catch (e) {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/service/cache.js